// extracted by mini-css-extract-plugin
module.exports = {"formBlock":"FormBlock_formBlock__1TjsA","title":"FormBlock_title__3dk0U","control":"FormBlock_control__3V_tM"};